module.exports = __webpack_public_path__ + "img/logo-red.d6084705.svg";